import { Component, OnInit, Input, Injectable, ViewChild, ElementRef, Inject } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { DOCUMENT } from '@angular/common';

import { ClientMockResponseComponent } from './capd-client-response/capd-client-response.component';
import { APIURL } from '../services/url.config';
import {throttleTime} from "rxjs/operators";
import {UntypedFormControl, UntypedFormGroup} from "@angular/forms";
import {CAPDAdminComponent} from "../capd-admin-component/capd-admin.component";

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'capd-client-mock',
    templateUrl: './capd-client-mock.component.html'
})
@Injectable()
export class CapdClientMock implements OnInit {
    @Input() public messageCards: any;
    @Input() public messageCard: any;
    @ViewChild(ClientMockResponseComponent)
    private responseComponent: ClientMockResponseComponent;

    hulkSession: string = 'false';
    // Hulk session parameters
    encounterId: any;
    mrn: any;
    debug: any = true;
    slim: any = true;
    jsobjectresponse: any = false;
    sessionId: any;
    oid: any;
    loginError: boolean = false;
    hulkError: boolean = false;

    // set url
    url = APIURL + 'capd-client/rest/incnlp/sessions?jsobjectresponse=false&slim=true&debug=true';
    urlExtensions = 'jsobjectresponse=false&slim=true&debug=true';

    // data returned from the get request
    @ViewChild('stickyMenu', { static: false }) menuElement: ElementRef;
    message: string;

    uiVersion: string = 'Classic';

    hulkSessionForm = new UntypedFormGroup({
        fdUsername: new UntypedFormControl(),
        fdPassword: new UntypedFormControl(),
        firstName: new UntypedFormControl(),
        middleName: new UntypedFormControl(),
        lastName: new UntypedFormControl(),
        gender: new UntypedFormControl(),
        dob: new UntypedFormControl(),
        targetApplication: new UntypedFormControl(),
        encounterId: new UntypedFormControl(),
        mrnValue: new UntypedFormControl(),
        appSchema: new UntypedFormControl(),
        user: new UntypedFormControl()
    });

    // set up all necessary connection tools
    @Input() public patient: any;
    constructor(
        private http: HttpClient,
        private route: ActivatedRoute,
        private router: Router,
        @Inject(DOCUMENT) private document: Document,
        public _adminComponent: CAPDAdminComponent) {
        this._adminComponent.uiChangeEvent.subscribe({
            next: (event) => {
                this.uiVersion = event
            }
        })
    }

    ngOnInit() {
        this.hulkSessionForm.value.targetApplication = "";
        this.uiVersion = sessionStorage.getItem('uiVersion');
    }

    getMessage(message) {
        if (message === 'Submitted') {
            this.message = message;
            this.responseComponent.message = message;
            this.responseComponent.getResponseData();
        }
    }

    setJsObjectResponse(input) {
        this.jsobjectresponse = input;
        this.setURL();
    }

    setSlim(input) {
        this.slim = input;
        this.setURL();
    }

    setDebug(input) {
        this.debug = input;
        this.setURL();
    }

    setURL() {
        // reinitialize url
        this.url = APIURL + 'capd-client/rest/incnlp/sessions?';
        this.urlExtensions = 'jsobjectresponse=false&slim=true&debug=true';

        // set jsobjectresponse
        if(this.jsobjectresponse == true || this.jsobjectresponse == 'true') {
            this.url = this.url + 'jsobjectresponse=true';
            this.urlExtensions = 'jsobjectresponse=true';
        } else {
            this.url = this.url + 'jsobjectresponse=false';
            this.urlExtensions = 'jsobjectresponse=false';
        }

        // set slim
        if(this.slim == true || this.slim == 'true') {
            this.url = this.url + '&slim=true';
            this.urlExtensions = this.urlExtensions + '&slim=true';
        } else {
            this.url = this.url + '&slim=false';
            this.urlExtensions = this.urlExtensions + '&slim=false';
        }

        // set debug
        if(this.debug == true || this.debug == 'true') {
            this.url = this.url + '&debug=true';
            this.urlExtensions = this.urlExtensions + '&debug=true';
        } else {
            this.url = this.url + '&debug=false';
            this.urlExtensions = this.urlExtensions + '&debug=false';
        }
    }

    async getHulkSession(formValues) {
        // set call headers
        let headers = new Headers();
        headers.append('Authorization', 'Basic ' + btoa(formValues.fdUsername + ':' + formValues.fdPassword));
        headers.append('Content-Type', 'application/json');

        // check variables are set appropriately -- fix if null or invalid
        if(formValues.firstName == null || formValues.firstName.length == 0) {
            formValues.firstName = "";
        }
        if(formValues.middleName == null || formValues.middleName.length == 0) {
            formValues.middleName = "";
        }
        if(formValues.lastName == null || formValues.lastName.length == 0) {
            formValues.lastName = "";
        }
        if(formValues.mrnValue == null || formValues.mrnValue.length == 0) {
            formValues.mrnValue = "";
        }
        if(formValues.gender == null || formValues.gender.length == 0) {
            formValues.gender = "";
        }
        if(formValues.dob == null || formValues.dob.length == 0) {
            formValues.dob = "";
        }
        if(formValues.targetApplication == null || formValues.targetApplication.length == 0) {
            formValues.targetApplication = "";
        }
        if(formValues.encounterId == null || formValues.encounterId.length == 0) {
            formValues.encounterId = "";
        }
        if(formValues.appSchema == null || formValues.appSchema.length == 0) {
            formValues.appSchema = "GenericSections";
        }

        // fill body parameters with form data collected
        const body = {
            associationId: 0,
            sessionNumber: 0,
            userName: formValues.fdUsername,
            capdSessionParameters: {
                'capd.patient.firstName': formValues.firstName.toString(),
                'capd.patient.middleName': formValues.middleName.toString(),
                'capd.patient.lastName': formValues.lastName.toString(),
                'capd.patient.mrn': formValues.mrnValue.toString(),
                'capd.patient.gender': formValues.gender.toString(),
                'capd.patient.dob': formValues.dob.toString(),
                'capd.targetApplication': formValues.targetApplication.toString(),
                'capd.customerAppRelativeEncounterId': formValues.encounterId.toString(),
            },
            hulkSessionParameters: {
                'nlp.appSchema': formValues.appSchema.toString(),
                'nlp.patiendDob': formValues.dob.toString(),
                'nlp.encounterId': formValues.encounterId.toString(),
                'com.mmodal.nlp.mrn': formValues.mrnValue.toString()
            }
        };

        let requestOptions: RequestInit = {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(body),
            redirect: 'follow'
        };

        this.hulkSession = 'loading';
        // Retrieve session and set session ID
        let session = await fetch(this.url, requestOptions);

        if(session.ok) {
            let result = await session.json();
            this.hulkSession = 'true';
            this.sessionId = result.sessionId;
            this.loginError = false;
            this.hulkError = false;
        } else {
            this.hulkSession = 'false';
            console.log("HTTP Error: ", session.status);
            if (session.status == 401) {
                this.loginError = true;
                this.hulkError = false;
            } else {
                this.loginError = false;
                this.hulkError = true;
            }
        }
    }

    async terminateSession(formValues) {
        let headers = new Headers();
        headers.append('Authorization', 'Basic ' + btoa(formValues.fdUsername + ':' + formValues.fdPassword));
        headers.append('cache-control', 'no-cache, private');
        headers.append('Content-Type', 'application/json');

        let body = "";

        let requestOptions = {
            method: 'DELETE',
            headers: headers,
            body: body
        };

        this.url = APIURL + 'capd-client/rest/incnlp/sessions/' + this.sessionId

        let terminate = fetch(this.url, requestOptions)
            .then(response => response.text())
            .then(() => {
                this.hulkSession = 'false';
                console.log('DELETE successful.');
                console.log('Session terminated.');
            }).catch(error => console.log('error', error));

        await terminate;
        this.setURL()
    }
}
